import React from 'react';
import { CheckCircle, RefreshCw } from 'lucide-react';

const SaveStatus = ({ isSaving }) => (
  <div className="fixed top-4 right-4 z-50">
    <div className={`flex items-center gap-2 px-3 py-1.5 rounded-full text-xs font-semibold transition-all duration-300 ${
      isSaving
        ? 'bg-blue-500/20 text-blue-300'
        : 'bg-emerald-500/20 text-emerald-300'
    }`}>
      {isSaving ? (
        <RefreshCw className="w-3.5 h-3.5 animate-spin" />
      ) : (
        <CheckCircle className="w-3.5 h-3.5" />
      )}
      <span>{isSaving ? 'Saving...' : 'Saved'}</span>
    </div>
  </div>
);

export default SaveStatus;
